import {
	CreateRefundRegister,
	EditRefundRegister,
	PaymentRefund,
	PaymentRefundList,
	RefundPaymentStatus
} from "./../../helper/types/refund";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ConfigurationService} from "@core/services/configuration.service";
import {Refund} from "@helper/types/refund";
import * as moment from "moment";
import {combineLatest, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {RefundsFilterFormValue} from "src/app/layout/refunds/service/refunds-filter-form-builder.service";
import {Store} from "@ngxs/store";
import {LayoutState} from "../../layout/layout.state";

export class Refunds {
	public services$ = this.store.select(LayoutState.services);

	public requests = {
		post$: (filter: RefundsFilterFormValue): Observable<PaymentRefund[]> => {
			const url = `${this.config.api.root}/refund/list`;

			const body = {
				dateFrom: moment(filter.period[0]).format("DD.MM.yyyy") + " 00:00:00",
				dateTo: moment(filter.period[1]).format("DD.MM.yyyy") + " 23:59:59",
				serviceCode: filter.service?.toString(),
				status: filter.status?.toString(),
			};

			return combineLatest([
				this.http.post<PaymentRefundList | null>(url, body, { withCredentials: true }),
				this.services$,
			]).pipe(
				map(([data, services]) => {
					const list = data?.PaymentRefund ?? []; // если null → []
					if (!list.length) {
						return [];
					}

					return list.map(register => {
						const actualRefundDate = register.actualRefundDate
							? moment(register.actualRefundDate, "DD.MM.YYYY HH:mm:ss").toDate()
							: null;

						const bidRefundDate = register.bidRefundDate
							? moment(register.bidRefundDate, "DD.MM.YYYY HH:mm:ss").toDate()
							: null;

						const serviceName = services.find(res => res[0].serviceCode === filter.service)?.[0]?.serviceName ?? "";

						return {
							...register,
							actualRefundDate,
							bidRefundDate,
							serviceName,
						};
					});
				})
			);
		},
	};

	public getStatus = {
		post$: (refundRequest: number): Observable<RefundPaymentStatus> => {
			const url = `${this.config.api.root}/refund/status`;
			const body = {
				refundRequest: {
					value: refundRequest
				},
			};
			return this.http.post<RefundPaymentStatus>(url, body, { withCredentials: true });
		}
	};

	public cancelRefundRecords = {
		delete$: (registerId: number): Observable<void> => {
			const url = `${this.config.api.root}/refund/cancelRefundRecords/${registerId}`;
			return this.http.delete<void>(url, { withCredentials: true });
		}
	};

	public get$(service: number, registerIds?: number[]): Observable<Refund[]> {
		const url = `${this.config.api.root}/refund`;
		let params = new HttpParams();
		params = params.append("serviceCode", service.toString());
		if (registerIds) {
			params = params.append("registerIds", registerIds.toString());
		}
		return this.http.get<{ refunds: Refund[] }>(url, { params, withCredentials: true }).pipe(map(data => data.refunds ? data.refunds : []));
	}

	public put$(value: EditRefundRegister) {
		const url = `${this.config.api.root}/refund/${value.registerId}`;
		return this.http.put(url, value, { withCredentials: true });
	}

	public post$(value: CreateRefundRegister): Observable<void> {
		const url = `${this.config.api.root}/refund`;
		return this.http.post<void>(url, value, { withCredentials: true });
	}

	public delete$(refundPaymentIds: number[], registerId?: number): Observable<void> {
		let params = new HttpParams();
		params = params.append("refundPaymentIds", refundPaymentIds.toString());
		if (registerId) {
			params = params.append("registerId", registerId.toString());
		}
		const url = `${this.config.api.root}/refund`;
		return this.http.delete<void>(url, { params, withCredentials: true });
	}

	constructor(private config: ConfigurationService, private http: HttpClient, private store: Store) { }
}
